"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgUncoveredSpot = function SvgUncoveredSpot(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M986.5 818.1h-79.3c1.3-3.7 1.9-7.6 1.9-11.6v-79.9c17.1-3.4 30-18.2 30-35.9V495.5h22.5c20.7 0 37.5-16.4 37.5-36.6V401c0-20.2-16.8-36.6-37.5-36.6h-60.2l-32.9-137.6c-13.2-55.4-61.4-94.1-117-94.1h-479c-55.7 0-103.8 38.7-117 94.1l-32.9 137.6H62.5C41.8 364.4 25 380.8 25 401v57.9c0 20.2 16.8 36.6 37.5 36.6H85v195.1c0 17.7 12.9 32.5 30 35.9v79.9c0 4.1.7 8 1.9 11.6H37.5C16.8 818.1 0 834.5 0 854.7s16.8 36.6 37.5 36.6h949.1c20.7 0 37.5-16.4 37.5-36.6s-16.9-36.6-37.6-36.6zm-277.8 3H295.2c1.4-4 2.2-8.3 2.2-12.8v-83.8h409v83.8c0 4.5.8 8.8 2.3 12.8zM191 364.8l28.7-123.6c5.2-22.6 23.1-38.3 43.4-38.3h473.7c20.3 0 38.1 15.8 43.3 38.3l28.7 123.6H191zm674.3 77.3v208.2H160.7V442.1h704.6zM152.4 830.6zM287.9 629c39.6 0 71.8-32.9 71.8-73.3s-32.2-73.3-71.8-73.3-71.8 32.9-71.8 73.3 32.2 73.3 71.8 73.3zm448.2 0c39.6 0 71.8-32.9 71.8-73.3s-32.2-73.3-71.8-73.3-71.8 32.9-71.8 73.3 32.2 73.3 71.8 73.3z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgUncoveredSpot, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;